import React from 'react';
import { useSelector } from 'react-redux';
import { Collapse, List, ListItem, ListItemIcon, ListItemText, makeStyles, Typography } from '@material-ui/core';

import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

import { IconChevronDown, IconChevronUp } from '@tabler/icons';

import NavItem from '../NavItem';
import { RootReduxState } from '../../../../../Redux/Store';
import PagePath, { PageType } from '../../../../../Route/PagePath';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    collapseIcon: {
        fontSize: '1rem',
        marginTop: 'auto',
        marginBottom: 'auto'
    },
    collapseIconSub: {
        fontSize: '1rem',
        marginTop: 'auto',
        marginBottom: 'auto'
    },
    menuIcon: {
        marginTop: 'auto',
        marginBottom: 'auto'
    },
    listIcon: {
        minWidth: '18px',
        marginTop: 'auto',
        marginBottom: 'auto'
    },
    listCustomIcon: {

    },
    listCustomIconSub: {
        width: '6px',
        height: '6px'
    },
    listCustomIconSubActive: {
        width: '8px',
        height: '8px'
    },
    listItem: {
        marginBottom: '5px',
        alignItems: 'flex-start'
    },
    listItemNoBack: {
        marginBottom: '5px',
        backgroundColor: 'transparent !important',
        paddingTop: '8px',
        paddingBottom: '8px',
        alignItems: 'flex-start'
    },
    subMenuCaption: {
        ...theme.typography.subMenuCaption
    },
    collapseWrapper: {
        position: 'relative',
        '&:after': {
            content: "''",
            position: 'absolute',
            left: '32px',
            top: 0,
            height: '100%',
            width: '1px',
            opacity: theme.palette.mode === 'dark' ? 0.2 : 1,
            background: theme.palette.mode === 'dark' ? theme.palette.dark.light : theme.palette.primary.light
        }
    },
    listItemTypography: {

    }
}));

interface NavCollapseProps {
    menu: PagePath
    level: number
}

const NavCollapse = (props: NavCollapseProps) => {
    const classes = useStyles();
    const location = useLocation();
    const customization = useSelector((state: RootReduxState) => state.customization);
    const { menu, level } = props;
    const [open, setOpen] = React.useState(false);
    const [selected, setSelected] = React.useState('');

    const handleClick = () => {
        setOpen(!open);
        setSelected(!selected ? menu.label : '');
    };

    React.useEffect(() => {
        const path = location.pathname;
        const hasActiveRoute = (items: PagePath[]): boolean => {
            return items.some((item) => {
                if (item.to && (path === item.to || path.startsWith(item.to + '/'))) {
                    return true;
                }
                if (item.content && item.content.length > 0) {
                    return hasActiveRoute(item.content);
                }
                return false;
            });
        };
        if (hasActiveRoute(menu.content || [])) {
            setOpen(true);
        }
    }, [location.pathname, menu.content]);



    if (!menu.content?.length) {
        menu.content = [];
    }

    const menus = menu.content.map((item: PagePath) => {
        var itemType = item.content?.length > 0 ? PageType.collapse : PageType.item;
        item.type = itemType;
        switch (itemType) {
            case PageType.collapse:
                return <NavCollapse key={item.label} menu={item} level={level + 1} />;
            case PageType.item:
                return <NavItem key={item.label} item={item} level={level + 1} />;
            default:
                return (
                    <Typography key={item.label} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    const Icon = menu.icon;
    const menuIcon = Icon ? (
        <Icon stroke={1.5} size="1.3rem" className={classes.listCustomIcon} />
    ) : (
        <FiberManualRecordIcon
            className={selected === menu.label ? classes.listCustomIconSubActive : classes.listCustomIconSub}
            fontSize='inherit'
        />
    );

    let menuIconClass = !menu.icon ? classes.listIcon : classes.menuIcon;

    return (
        <React.Fragment>
            <ListItem
                key={menu.label}
                className={level > 1 ? classes.listItemNoBack : classes.listItem}
                selected={selected === menu.label}
                button
                onClick={handleClick}
                style={{ paddingLeft: level * 23 + 'px', borderRadius: customization.borderRadius + 'px' }}
            >
                <ListItemIcon className={menuIconClass}>{menuIcon}</ListItemIcon>
                <ListItemText
                    primary={
                        <Typography variant={selected === menu.label ? 'h5' : 'body1'} color="inherit" className={classes.listItemTypography}>
                            <FormattedMessage id={menu.LocalePath} defaultMessage={menu.label} />
                        </Typography>
                    }
                    secondary={
                        menu.description && (
                            <Typography variant="caption" className={classes.subMenuCaption} display="block" gutterBottom>
                                <FormattedMessage id={menu.description} defaultMessage={menu.description} />
                            </Typography>
                        )
                    }
                />
                {open ? (
                    <IconChevronUp stroke={1.5} size="1rem" className={level > 1 ? classes.collapseIconSub : classes.collapseIcon} />
                ) : (
                    <IconChevronDown stroke={1.5} size="1rem" className={level > 1 ? classes.collapseIconSub : classes.collapseIcon} />
                )}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding className={classes.collapseWrapper}>
                    {menus}
                </List>
            </Collapse>
        </React.Fragment>
    );
};

export default NavCollapse;
